import { SortDestinationColorSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-destination";
import { SortDispositionSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-disposition";
import { inventoryItemIdFormat } from "@redotech/redo-ims-id";
import * as z from "zod";

/**
 * Bin-free guidance for the receive-to-bin floor panel. Null unless the account's
 * own destinations agree on one colour: guidance invents none.
 */
export const getReceiveGuidance = {
  name: "getReceiveGuidance" as const,
  input: z.object({ inventoryItemId: inventoryItemIdFormat.schema }),
  output: z.object({
    guidance: z
      .object({
        disposition: SortDispositionSchema,
        color: SortDestinationColorSchema,
        merchantName: z.string().nullable(),
      })
      .nullable(),
    // Set when the unit already sits in a bin: a stale-label heads-up at scan.
    alreadyReceived: z.object({ binName: z.string() }).nullable(),
  }),
};

export type GetReceiveGuidanceInput = z.infer<typeof getReceiveGuidance.input>;
export type GetReceiveGuidanceOutput = z.infer<
  typeof getReceiveGuidance.output
>;
